import { searchQueryKeyMap } from '@/features/search/_utils/query-keys';

export const queryKeyMap = {
  projects: searchQueryKeyMap.projects,
  projectSummary: (params?: object) =>
    ['projectSummary', params].filter((item) => item !== undefined),
  projectsOptions: (params?: object) =>
    ['projectsOptions', params].filter((item) => item !== undefined),
  projectIds: (params?: object) =>
    ['projectIds', params].filter((item) => item !== undefined),
  priorProjectId: (params?: object) =>
    ['priorProjectId', params].filter((item) => item !== undefined),
  projectGroup: (id?: string) =>
    ['projectGroup', id].filter((item) => item !== undefined),
  projectGroupMeta: (id: string) => ['projectGroupMeta', id],
  projectGroupSummary: (id?: string) =>
    ['projectGroupSummary', id].filter((item) => item !== undefined),
  groupProjects: (id?: string, page?: string, ordering?: string | null) =>
    [
      'groupProjects',
      id,
      page === undefined && ordering === undefined
        ? undefined
        : { page, ordering },
    ].filter((item) => item !== undefined),
  groupSavepoints: (id?: string, params?: object) =>
    ['groupSavepoints', id, params].filter((item) => item !== undefined),
  groupSavepoint: (projectId: string, savepointId: string) => [
    'groupSavepoint',
    projectId,
    savepointId,
  ],
  groupSavepointsAuthors: (id: string) => ['groupSavepointsAuthors', id],
  project: (id?: string, params?: object) =>
    ['project', id, params].filter((item) => item !== undefined),
  savepoints: (id?: string, params?: object) =>
    ['savepoints', id, params].filter((item) => item !== undefined),
  savepoint: (projectId: string, savepointId: string) =>
    ['savepoint', projectId, savepointId].filter(Boolean),
  savepointsAuthors: (id: string) => ['savepointsAuthors', id].filter(Boolean),
  projectDiff: (
    id?: string,
    params?: {
      datetimeAt?: string;
      budgetTypeOption?: string;
    },
  ) => ['projectDiff', id, params].filter((item) => item !== undefined),
  groupProjectNextAndPrevious: (id: string, groupId: string) => [
    'groupProjectNextAndPrevious',
    id,
    groupId,
  ],
  expenditureCarts: (params?: object) =>
    ['expenditureCarts', params].filter((item) => item !== undefined),
  frameAllocationProjectSummary: (id?: string) =>
    ['frameAllocationProjectSummary', id].filter((item) => item !== undefined),
  frameAllocationAmountByOrganizationId: (params: {
    fiscalYear: string;
    organizationId: string;
  }) => ['frameAllocationAmountByOrganizationId', params],
  frameAllocationSummary: (params?: {
    fiscalYear: string;
    organizationId?: string;
  }) => ['frameAllocationSummary', params].filter(Boolean),
  frameAllocationProjectList: (id: string) => [
    'frameAllocationProjectList',
    id,
  ],
  frameAllocationList: (params?: {
    fiscalYear: string;
    organizationId?: string;
  }) => ['frameAllocationList', params].filter((item) => item !== undefined),
  frameAllocationAdjustmentList: (params?: {
    fiscalYear: string;
    organizationId?: string;
  }) =>
    ['frameAllocationAdjustmentList', params].filter(
      (item) => item !== undefined,
    ),
  subProjects: (projectId?: string) =>
    ['subProjects', projectId].filter((item) => item !== undefined),
  consecutiveFiscalYears: (id?: string) =>
    ['consecutiveFiscalYears', id].filter((item) => item !== undefined),
  consecutiveTotalAmount: (id?: string) =>
    ['consecutiveTotalAmount', id].filter((item) => item !== undefined),
  consecutivePostEvaluations: (projectId: string) => [
    'consecutivePostEvaluations',
    projectId,
  ],
  relatedMaterials: (projectId?: string) =>
    ['relatedMaterials', projectId].filter((item) => item !== undefined),
  totalAmountSummary: (projectId: string, budgetTypeId?: string) =>
    ['totalAmount', projectId, budgetTypeId].filter(
      (item) => item !== undefined,
    ),
  budgetSummary: (projectId: string, budgetTypeId?: string) =>
    ['budgetSummary', projectId, budgetTypeId].filter(
      (item) => item !== undefined,
    ),
  projectFormats: () => ['projectFormats'],
  layoutSettings: (formatId: string) => ['layoutSettings', formatId],
  distributionRequestExpenditureCart: (expenditureCartId: string) => [
    'project',
    'distributionRequestExpenditureCart',
    expenditureCartId,
  ],

  projectNotification: (projectId?: string) =>
    ['projectNotification', projectId].filter((item) => item !== undefined),
  executionProjects: (params?: object) =>
    ['executionProjects', params].filter((item) => item !== undefined),
  executionProjectOptions: (params?: object) =>
    ['executionProjectOptions', params].filter((item) => item !== undefined),
  executionProject: (id?: string, params?: object) =>
    ['executionProject', id, params].filter((item) => item !== undefined),
  executionProjectCarriedForwardInfo: (
    executionProjectId?: string,
    params?: object,
  ) =>
    ['executionProjectCarriedForwardInfo', executionProjectId, params].filter(
      (item) => item !== undefined,
    ),
  executionProjectFiscalYears: (executionProjectId: string, params?: object) =>
    ['executionProjectFiscalYears', executionProjectId, params].filter(
      (item) => item !== undefined,
    ),
  executionProjectExpenditureNatureWithCartAndSummaries: (
    executionProjectId: string,
    params?: object,
  ) =>
    [
      'executionProjectExpenditureNatureWithCartAndSummaries',
      executionProjectId,
      params,
    ].filter((item) => item !== undefined),
  executionCart: (
    executionProjectId: string,
    executionCartId?: string,
    params?: object,
  ) =>
    ['executionCart', executionProjectId, executionCartId, params].filter(
      (item) => item !== undefined,
    ),
  executionSubItems: (
    executionProjectId: string,
    executionCartId?: string,
    params?: object,
  ) =>
    ['executionSubItems', executionProjectId, executionCartId, params].filter(
      (item) => item !== undefined,
    ),
  executionSubItem: (
    executionProjectId: string,
    executionCartId?: string,
    executionItemId?: string,
    executionSubItemId?: string,
    params?: object,
  ) =>
    [
      'executionSubItem',
      executionProjectId,
      executionCartId,
      executionItemId,
      executionSubItemId,
      params,
    ].filter((item) => item !== undefined),
  executionDetails: (
    executionProjectId?: string,
    executionCartId?: string,
    executionItemId?: string,
    executionSubItemId?: string,
    params?: object,
  ) =>
    [
      'executionDetails',
      executionProjectId,
      executionCartId,
      executionItemId,
      executionSubItemId,
      params,
    ].filter((item) => item !== undefined),
  activity: (projectId: string, activityId: string) => [
    'activity',
    projectId,
    activityId,
  ],
  activities: (projectId: string) => ['activities', projectId],
  midtermEvaluations: (projectId: string) => ['midtermEvaluations', projectId],
  midtermEvaluation: (projectId: string, midtermEvaluationId?: string) =>
    ['midtermEvaluation', projectId, midtermEvaluationId].filter(
      (item) => item !== undefined,
    ),
  midtermReports: (projectId: string) => ['midtermReports', projectId],
  midtermReport: (projectId: string, midtermReportId?: string) =>
    ['midtermReport', projectId, midtermReportId].filter(
      (item) => item !== undefined,
    ),
  projectIdentifier: (id?: string) =>
    ['projectIdentifier', id].filter((item) => item !== undefined),
};
